import React from 'react';
import { Container, Typography } from '@mui/material';

function SaveNewPassword() {
	return (
		<Container>
			<Typography variant="h4"> Neues Passwort speichern</Typography>
		</Container>
	);
}

export default SaveNewPassword;
